﻿console.log("Starduck");

import "Common/ErrorReporting";
import "./Framework/Environment";
